import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var CloudSun = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M122.4 1.2c5.2-2.1 11-1.4 15.5 1.8l70.3 50.3L278.5 3c4.5-3.2 10.3-3.9 15.4-1.8s8.8 6.7 9.7 12.2l14.1 85.3 85.3 14.1c5.4.9 10.1 4.6 12.2 9.7s1.4 10.9-1.8 15.4l-38.8 54.3c-2.2-.1-4.3-.2-6.5-.2-23.2 0-45 6.2-63.8 17 .1-12.5-2.2-25.3-7.3-37.6-20.3-49-76.4-72.2-125.4-52s-72.2 76.4-52 125.4c18.3 44.3 66 67.5 111.1 56.6-36.3 18.2-62.8 53.3-69.1 94.9L138 413.2c-4.5 3.2-10.3 3.9-15.4 1.8s-8.8-6.7-9.7-12.2l-14.2-85.1-85.3-14.1c-5.5-.9-10.1-4.6-12.2-9.7s-1.4-11 1.8-15.4l50.3-70.3L3 137.9c-3.2-4.5-3.9-10.3-1.8-15.4s6.7-8.8 12.2-9.7l85.3-14.1 14.1-85.3a16 16 0 0 1 9.7-12.2zM149 232.7c-13.5-32.7 2-70.1 34.6-83.6s70.1 2 83.6 34.6-2 70.1-34.6 83.6-70.1-2-83.6-34.6zm490.9 199.2c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6V320c0-53 43-96 96-96 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z"
  }));
});
CloudSun.displayName = 'CloudSun';
export var CloudSunDimensions = {
  height: 512,
  width: 640
};